import { SharedModule } from '@/shared.module';
import { NgModule } from '@angular/core';
import { MollieRedirectCatcherComponent } from './mollie-redirect-catcher/mollie-redirect-catcher.component';

@NgModule({
  declarations: [MollieRedirectCatcherComponent],
  imports: [SharedModule],
  exports: [MollieRedirectCatcherComponent],
})
export class MollieModule {}
